import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/expand.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "2", -1)
const _hoisted_2 = { class: "choose-goods" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "item-wrap" }
const _hoisted_5 = { class: "item-return-options" }
const _hoisted_6 = { class: "note-picture" }
const _hoisted_7 = { class: "custom-textarea" }
const _hoisted_8 = { class: "add-pictures" }
const _hoisted_9 = ["id"]
const _hoisted_10 = ["id"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  id: "picture-output",
  class: "picture-output"
}, null, -1)
const _hoisted_12 = ["title"]
const _hoisted_13 = ["onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemDetail = _resolveComponent("ItemDetail")!
  const _component_CustomSelectItemReason = _resolveComponent("CustomSelectItemReason")!
  const _component_CustomTextArea = _resolveComponent("CustomTextArea")!
  const _component_CloseBtn = _resolveComponent("CloseBtn")!
  const _component_CustomCard = _resolveComponent("CustomCard")!

  return (_openBlock(), _createBlock(_component_CustomCard, {
    optClass: "step",
    hidden: _ctx.hidden
  }, {
    "step-number": _withCtx(() => [
      _hoisted_1
    ]),
    "step-title": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("NEW_TICKET.CHOOSE_ITEMS")), 1)
    ]),
    optional: _withCtx(() => [
      _createElementVNode("img", {
        src: _imports_0,
        class: _normalizeClass(["expand", { hidden: !_ctx.hidden }])
      }, null, 2)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, itemIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            id: "item",
            class: _normalizeClass(["good-item", { checked: item.isChosen }]),
            "data-cy": "item"
          }, [
            _createElementVNode("div", {
              id: "item-checkbox",
              onClick: ($event: any) => (_ctx.setProperty(item, 'isChosen')),
              class: _normalizeClass(["custom-checkbox", {
              checked: item.isChosen,
              invalid:
                _ctx.chosenItems.length === 0 &&
                !_ctx.isCreatedRmaValid &&
                _ctx.doneButtonClicked
            }])
            }, null, 10, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ItemDetail, { item: item }, null, 8, ["item"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_CustomSelectItemReason, {
                  item: item,
                  invalid: _ctx.isSelectInvalid(item),
                  claimReasons: _ctx.claimReasons,
                  onSelectVisibleChanged: ($event: any) => (_ctx.setProperty(item, 'selectVisible')),
                  onOptionChanged: (...args) => _ctx.changeOption(item, ...args)
                }, null, 8, ["item", "invalid", "claimReasons", "onSelectVisibleChanged", "onOptionChanged"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_CustomTextArea, {
                      insideText: item.note,
                      "onUpdate:insideText": ($event: any) => ((item.note) = $event),
                      placeholderText: _ctx.t('NEW_TICKET.ADD_NOTE')
                    }, null, 8, ["insideText", "onUpdate:insideText", "placeholderText"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "pictures",
                    id: 'pictures-' + itemIndex
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pictures, (picture, picIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: picture,
                        class: "picture",
                        id: 'picture-' + itemIndex + '-' + picIndex
                      }, [
                        _hoisted_11,
                        _createVNode(_component_CloseBtn, {
                          onClick: ($event: any) => (_ctx.deleteLoadedImage(itemIndex, picIndex))
                        }, null, 8, ["onClick"])
                      ], 8, _hoisted_10))
                    }), 128))
                  ], 8, _hoisted_9),
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickOnUpload && _ctx.clickOnUpload(...args))),
                    class: _normalizeClass(["add-picture-icon", {
                    hidden: _ctx.getPicturesLength(itemIndex) >= 3
                  }]),
                    title: _ctx.t('NEW_TICKET.ADD_PICTURE')
                  }, null, 10, _hoisted_12),
                  _createElementVNode("input", {
                    id: "image-input",
                    type: "file",
                    accept: "image/*",
                    onChange: ($event: any) => (_ctx.loadImage(itemIndex, $event)),
                    style: {"display":"none"}
                  }, null, 40, _hoisted_13)
                ])
              ])
            ])
          ], 2))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["hidden"]))
}